var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueCalendarCardBenefitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589355,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#E7F0FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6309_10005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6663 14.5894V13.256C24.6663 13.0792 24.5961 12.9096 24.4711 12.7846C24.3461 12.6596 24.1765 12.5894 23.9997 12.5894C23.8229 12.5894 23.6533 12.6596 23.5283 12.7846C23.4032 12.9096 23.333 13.0792 23.333 13.256V14.5894H24.6663Z",
    fill: "#077ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 14.5894V13.256C16.6663 13.0792 16.5961 12.9096 16.4711 12.7846C16.3461 12.6596 16.1765 12.5894 15.9997 12.5894C15.8229 12.5894 15.6533 12.6596 15.5283 12.7846C15.4032 12.9096 15.333 13.0792 15.333 13.256V14.5894H16.6663Z",
    fill: "#077ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27.9225H14C13.4696 27.9225 12.9609 27.7118 12.5858 27.3367C12.2107 26.9617 12 26.453 12 25.9225V17.2559C12 16.7254 12.2107 16.2167 12.5858 15.8416C12.9609 15.4666 13.4696 15.2559 14 15.2559H26C26.5304 15.2559 27.0391 15.4666 27.4142 15.8416C27.7893 16.2167 28 16.7254 28 17.2559V25.9225C28 26.453 27.7893 26.9617 27.4142 27.3367C27.0391 27.7118 26.5304 27.9225 26 27.9225ZM26.6667 18.5892H13.3333V25.9225C13.3333 26.0993 13.4036 26.2689 13.5286 26.3939C13.6536 26.519 13.8232 26.5892 14 26.5892H26C26.1768 26.5892 26.3464 26.519 26.4714 26.3939C26.5964 26.2689 26.6667 26.0993 26.6667 25.9225V18.5892Z",
    fill: "#077ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 19.9229H14.667V21.9229H17.3337V19.9229Z",
    fill: "#077ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 19.9229H18.667V21.9229H21.3337V19.9229Z",
    fill: "#077ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 23.2559H14.667V25.2559H17.3337V23.2559Z",
    fill: "#077ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 23.2559H18.667V25.2559H21.3337V23.2559Z",
    fill: "#077ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3337 19.9229H22.667V21.9229H25.3337V19.9229Z",
    fill: "#077ACC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6309_10005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5894)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCalendarCardBenefitIcon);
export default __webpack_public_path__ + "static/media/blue-calendar-card-benefit-icon.a0291198affffc30b71eea7e7b9e8df1.svg";
export { ForwardRef as ReactComponent };